<template lang="pug">
div
  .input-range_label.theme--light.v-label.text-truncate.caption {{label}}
  v-layout(row align-center)
    v-flex: input-datetime.nolabel(:value="von" @input="input($event, bis)" :hide-details="hideDetails" :disabled="disabled" :error-messages="errorMessages")
    v-flex.pl-1
    v-flex: input-datetime.nolabel(:value="bis" @input="input(von, $event)" :hide-details="hideDetails" :disabled="disabled")
    v-flex(v-if="!disabled && clearable && (von || bis)"): v-icon(@click="clear") clear

</template>

<style lang="stylus" scoped>
.nolabel > >>> .v-input
  margin-top 0
  padding-top 0

.input-range_label
  margin-top 4px

</style>

<script>

export default {
  name: 'input-datetime-range',
  props: {
    value: [Array, Object],
    array: Boolean,
    label: String,
    clearable: Boolean,
    hideDetails: Boolean,
    disabled: Boolean,
    errorMessages: {
      type: Array,
      default() { return [] }
    }
  },
  data() {
    return {
      von: null,
      bis: null,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (Array.isArray(value)) {
          this.von = value[0] || null
          this.bis = value[1] || null
        } else if (value !== null && typeof value === 'object') {
          this.von = value.von || null
          this.bis = value.bis || null
        } else {
          this.von = null
          this.bis = null
        }
      }
    }
  },
  methods: {
    input(von, bis) {
      if (von && bis && von > bis) {
        this.von = bis
        this.bis = von
      } else {
        this.von = von
        this.bis = bis
      }
      this.emit()
    },
    clear() {
      this.von = null
      this.bis = null
      this.emit()
    },
    emit() {
      if (!this.von && !this.bis) {
        this.$emit('input', null)
      } else if (this.array) {
        this.$emit('input', [this.von, this.bis])
      } else {
        this.$emit('input', { von: this.von, bis: this.bis })
      }
    }
  }
}
</script>
